import { Typography } from "@mui/material";

import { withForm } from "components/Forms/AppForm";
import { defaultMailListValues } from "features/memberPortal/mail/components/MailList/MailList.schema";

import { DetailCardMode } from "../MailListDetails.types";

const DetailCardTitle = withForm({
  defaultValues: defaultMailListValues,
  props: {
    title: "",
    mode: "view" as DetailCardMode,
  },
  render: ({ form, title, mode }) => {
    if (mode === "view") {
      return <Typography variant="h2">{title}</Typography>;
    }

    return (
      <form.AppField name="name">
        {(field) => <field.TextInput label="Mail List Name" required />}
      </form.AppField>
    );
  },
});

export default DetailCardTitle;
